<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>
<div [ngClass]="{'p-3': !desdeCaja}">
    <ngx-kuv-venta [productos]="productos" (cancelado)="cancelar()" (completado)="registrar($event)" [cleanVenta]="clearEmitter" [useDescuento]="false" [useDescuentoLinea]="false" [useEncargadoDespacho]="false" [useDespacho]="false" [useTipoDocumento]="false" [usePago]="false" [useImpuesto]="false" [clientes]="proveedores" [addCliente]="addProveedor" [esCompra]="true"></ngx-kuv-venta>
</div>
